import { RegistrationRequest, RegistrationResponse } from '@/api/generated';
import { api } from '@services/api-service';
import urlsService from '@services/urls-service';
import { businessAccountFormValues } from './form-schemas';

const prepareValues = (fromValues: businessAccountFormValues): RegistrationRequest => {
  const countryCode = JSON.parse(fromValues.countryCode as string).code;
  const preparedValues: RegistrationRequest = {
    sex: fromValues.sex,
    firstName: fromValues.firstName,
    lastName: fromValues.lastName,
    emailAddress: fromValues.emailAddress,
    street: fromValues.street,
    houseNumber: fromValues.houseNumber,
    houseNumberAddition: fromValues.houseNumberAddition,
    city: fromValues.city,
    postalCode: fromValues.postalCode,
    companyName: fromValues.companyName,
    countryCode,
    createAccount: {
      username: fromValues.username,
      password: fromValues.password,
      repeatPassword: fromValues.repeatPassword
    },
    deliveryAddress: !fromValues.hasDeliveryAddress
      ? undefined
      : {
          deliveryStreet: fromValues.deliveryStreet,
          deliveryHouseNumber: fromValues.deliveryHouseNumber,
          deliveryHouseNumberAddition: fromValues.houseNumberAddition,
          deliveryPostalCode: fromValues.deliveryPostalCode,
          deliveryCity: fromValues.deliveryCity
        },
    phoneNumber: fromValues.phoneNumber,
    registrationNr: fromValues.registrationNr,
    vatRegistrationNr: fromValues.vatRegistrationNr
  };

  return preparedValues;
};

export const registerClient = {
  registerBusinessAccount: (values: businessAccountFormValues) => {
    const submitValues = prepareValues(values);

    return api.post<RegistrationResponse>({
      url: urlsService.getUrl('/register'),
      data: { ...submitValues } as unknown as JSONObject
    });
  }
};
